import { AdminCallHistoryCard } from '@/features/calls/components/AdminCallHistoryCard';

/**
 * Full paginated list of every session on the platform (calls + paid chat).
 * The card in global view (no callerId/professionalId) does all the work.
 */
export function AdminActivitiesPage() {
  return (
    <div className="space-y-6">
      <div className="rounded-2xl bg-gradient-to-r from-brand-navy via-[#1c1a4d] to-brand-teal-600 p-6">
        <h1 className="text-2xl font-bold text-white">Attività</h1>
        <p className="mt-1 text-sm text-white/70">
          Tutte le chiamate e le sessioni chat della piattaforma
        </p>
      </div>

      <AdminCallHistoryCard />
    </div>
  );
}
